import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterLink, RouterModule } from '@angular/router';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import { UserInnerComponent } from './user-inner/user-inner.component';
import {
  AuthService,
  NotificationsService,
} from '../../services';
import { NotificationsInnerComponent } from './notifications-inner/notifications-inner.component';
import { BadgeModule } from 'primeng/badge';
import { APP_NAME } from '../../utils';
import {
  NotificationI,
  SignalRService,
} from '../../services/signalr/signal-r.service';
@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterModule,
    StyleClassModule,
    UserInnerComponent,
    NotificationsInnerComponent,
    BadgeModule,
    RouterLink,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <div class="layout-topbar">
    @if(layoutService.isMobile()){
    <div class="flex align-items-center gap-2 flex-wrap">
      <button class="layout-menu-button" (click)="toggleSidebar()">
        <i class="fa-solid fa-bars"></i>
      </button>
      <a routerLink="/">
        <img alt="Logo" [src]="sidebarLogo()" class="!h-[30px]" />
      </a>
    </div>
    }
    <div class="layout-topbar-actions">
      <div class="layout-topbar-menu ">
        <div class="layout-topbar-menu-content !h-[50px]">
          <div class="relative ">
            <div class="cursor-pointer">
              <button
                type="button"
                class="layout-topbar-action w-full !text-white"
                (click)="downloadUserManual()"
              >
                <a
                  [href]="userManual()"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="text-decoration: none; color: inherit;"
                >
                  <i
                    class="fa-regular fa-circle-question text-primary !text-2xl"
                  ></i>
                </a>
              </button>
            </div>
          </div>
          <div class="relative ">
            <div
              class="cursor-pointer"
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-scalein"
              leaveToClass="hidden"
              leaveActiveClass="animate-fadeout"
              [hideOnOutsideClick]="true"
            >
              <button
                type="button"
                class="layout-topbar-action w-full !text-white"
                [value]="notifications().length"
              >
                <i class="far fa-bell text-primary !text-2xl"></i>
                @if(notifications().length>0){
                <div
                  class="absolute -top-3 -start-4 bg-primary rounded-full p-3 w-4 h-4 flex items-center justify-center"
                >
                  <span class="!text-xs" aria-label="New notifications">
                    {{ notifications().length }}
                  </span>
                </div>
                }
              </button>
            </div>
            <notifications-inner [(notifications)]="notifications" />
          </div>
          <div class="relative ">
            <div
              class="!h-[40px] !w-[40px] cursor-pointer"
              pStyleClass="@next"
              enterFromClass="hidden"
              enterActiveClass="animate-scalein"
              leaveToClass="hidden"
              leaveActiveClass="animate-fadeout"
              [hideOnOutsideClick]="true"
            >
              <img
                height="50"
                width="50"
                class="!h-[40px] !w-[40px] !object-cover rounded-xl"
                src="./assets/media/avatars/blank.png"
              />
            </div>
            <user-inner />
          </div>
        </div>
      </div>
    </div>
  </div>`,
})
export class AppTopbar implements OnInit {
  layoutService = inject(LayoutService);
  notificationService = inject(NotificationsService);
  authService = inject(AuthService);
  signalRService = inject(SignalRService);
  private appName = inject(APP_NAME);

  items!: MenuItem[];
  newNotifications: PrimengNotifications[] = [];
  notifications: WritableSignal<any> = signal([]);
  notificationCount: number = 0;

  sidebarLogo = signal(
    this.appName === 'coassess'
      ? 'assets/coassess-login.png'
      : 'assets/coreact.png'
  );
  userManual = signal(
    this.appName === 'coassess'
      ? '/assets/coassess-manual.pdf'
      : '/assets/coreact-manual.pdf'
  );

  constructor() {
    effect(() => {
      const incoming = this.signalRService.notifications();
      if (incoming.length) this.processNewNotifications(incoming);
    });
  }
  ngOnInit(): void {
  }
  toggleSidebar() {
    this.layoutService.layoutState.update((prev) => ({
      ...prev,
      staticMenuMobileActive:
        !this.layoutService.layoutState().staticMenuMobileActive,
    }));
  }
  downloadUserManual() { }

  private processNewNotifications(notifications: NotificationI[]): void {
    const newNotifications: PrimengNotifications[] = notifications
      .map((item) => {
        const exists = this.newNotifications.some((msg) => msg.id === item.id);
        if (!exists) {
          this.playSound();
          return {
            id: item.id,
            severity: '',
            summary: 'Νέα ειδοποίηση',
            detail: item.id,
            viewed: false,
          };
        }
        return null;
      })
      .filter((item): item is PrimengNotifications => item !== null);

    this.notifications.update((prev) => [...prev, ...newNotifications]);
    this.updateNotificationCount();
  }

  private updateNotificationCount(): void {
    this.notificationCount = this.newNotifications.filter(
      (item) => !item.viewed
    ).length;
  }

  private playSound() {
    let audio = new Audio();
    audio.src = '../../../../assets/media/sounds/notification-sound.mp3';
    audio.load();
    audio.play();
  }

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));
  }
}

export interface PrimengNotifications {
  id: string;
  severity: string;
  summary: string;
  detail: string;
  viewed: boolean;
}
